export default [
  { // 2-1
    path: "/SciencePlatform/Country",
    name: "Country",
    component: () => import("../views/SciencePlatform/Country"),
  },
  { // 2-2
    path: "/SciencePlatform/Province",
    name: "Province",
    component: () => import("../views/SciencePlatform/Province"),
  },
  { // 2-3
    path: "/SciencePlatform/City",
    name: "City",
    component: () => import("../views/SciencePlatform/City"),
  },
  {
    // 2-4
    path: "/SciencePlatform/ScienceFarmPark",
    name: "ScienceFarmPark",
    component: () => import("../views/SciencePlatform/ScienceFarmPark"),
  },
  {
    // 2-5
    path: "/SciencePlatform/InterUniLab",
    name: "InterUniLab",
    component: () => import("../views/SciencePlatform/InterUniLab"),
  },
];
